import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
const privacyContent = <div className="space-y-4 text-dark-brown/80" data-id="element-45">
    <h3 className="text-xl font-bold text-dark-brown" data-id="element-46">
      Política de Privacidad
    </h3>
    <p data-id="element-47">
      <strong data-id="element-48">Última actualización:</strong> Abril 2026
    </p>
    <p data-id="element-49">
      En Plan Detox de Azúcar, respetamos tu privacidad. Esta política describe
      cómo recopilamos, usamos y protegemos tu información personal cuando
      utilizas nuestro sitio web y adquieres nuestros productos digitales.
    </p>
    <h4 className="font-bold text-dark-brown mt-4" data-id="element-50">
      Información que Recopilamos
    </h4>
    <ul className="list-disc pl-5 space-y-1" data-id="element-51">
      <li data-id="element-52">Nombre y dirección de correo electrónico al momento de la compra.</li>
      <li data-id="element-53">
        Información de pago procesada de forma segura a través de nuestro
        proveedor de pagos (no almacenamos datos de tarjetas).
      </li>
      <li data-id="element-54">
        Datos de navegación anónimos para mejorar la experiencia del usuario.
      </li>
    </ul>
    <h4 className="font-bold text-dark-brown mt-4" data-id="element-55">Uso de la Información</h4>
    <ul className="list-disc pl-5 space-y-1" data-id="element-56">
      <li data-id="element-57">Procesar tu compra y entregar el producto digital.</li>
      <li data-id="element-58">Enviarte actualizaciones relacionadas con tu compra.</li>
      <li data-id="element-59">Mejorar nuestros productos y servicios.</li>
    </ul>
    <h4 className="font-bold text-dark-brown mt-4" data-id="element-60">Protección de Datos</h4>
    <p data-id="element-61">
      Implementamos medidas de seguridad estándar de la industria para proteger
      tu información personal. No vendemos, intercambiamos ni transferimos tu
      información personal a terceros sin tu consentimiento.
    </p>
    <h4 className="font-bold text-dark-brown mt-4" data-id="element-62">Tus Derechos</h4>
    <p data-id="element-63">
      Puedes solicitar acceso, corrección o eliminación de tus datos personales
      en cualquier momento enviándonos una solicitud por escrito.
    </p>
  </div>;
const termsContent = <div className="space-y-4 text-dark-brown/80" data-id="element-64">
    <h3 className="text-xl font-bold text-dark-brown" data-id="element-65">
      Términos y Condiciones
    </h3>
    <p data-id="element-66">
      <strong data-id="element-67">Última actualización:</strong> Abril 2026
    </p>
    <p data-id="element-68">
      Al acceder y utilizar este sitio web y adquirir nuestros productos
      digitales, aceptas los siguientes términos y condiciones.
    </p>
    <h4 className="font-bold text-dark-brown mt-4" data-id="element-69">Producto Digital</h4>
    <p data-id="element-70">
      El Plan Detox de Azúcar 7 Días es un producto digital informativo en
      formato PDF. Al completar tu compra, recibirás acceso inmediato para
      descargar el material.
    </p>
    <h4 className="font-bold text-dark-brown mt-4" data-id="element-71">Uso Personal</h4>
    <p data-id="element-72">
      El contenido adquirido es para uso personal únicamente. Queda prohibida la
      reproducción, distribución o reventa del material sin autorización expresa
      por escrito.
    </p>
    <h4 className="font-bold text-dark-brown mt-4" data-id="element-73">
      Descargo de Responsabilidad Médica
    </h4>
    <p data-id="element-74">
      La información proporcionada en esta guía es de carácter informativo y
      educativo. No sustituye el consejo, diagnóstico o tratamiento médico
      profesional. Consulta siempre a tu médico antes de iniciar cualquier plan
      de alimentación o cambio en tu dieta.
    </p>
    <h4 className="font-bold text-dark-brown mt-4" data-id="element-75">Resultados</h4>
    <p data-id="element-76">
      Los resultados pueden variar de persona a persona. Los testimonios y
      ejemplos mencionados no garantizan resultados específicos.
    </p>
    <h4 className="font-bold text-dark-brown mt-4" data-id="element-77">Política de Reembolso</h4>
    <p data-id="element-78">
      Debido a la naturaleza digital del producto, todas las ventas son finales.
      Si tienes algún problema con tu compra, nos comprometemos a ayudarte a
      resolver cualquier inconveniente.
    </p>
  </div>;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="bg-dark-brown text-cream/60 py-8 text-center text-sm" data-id="element-79">
        <p data-id="element-80">
          © {new Date().getFullYear()} Plan Detox de Azúcar. Todos los derechos
          reservados.
        </p>
        <p className="mt-2 text-xs max-w-2xl mx-auto px-4 opacity-50" data-id="element-81">
          Descargo de responsabilidad: La información proporcionada no sustituye
          el consejo médico profesional. Consulte a su médico antes de comenzar
          cualquier plan de alimentación.
        </p>
        <div className="mt-4 flex items-center justify-center space-x-6" data-id="element-82">
          <button onClick={() => setActiveModal('privacy')} className="text-cream/50 hover:text-cream transition-colors underline underline-offset-2" data-id="element-83">
            Política de Privacidad
          </button>
          <span className="text-cream/30" data-id="element-84">|</span>
          <button onClick={() => setActiveModal('terms')} className="text-cream/50 hover:text-cream transition-colors underline underline-offset-2" data-id="element-85">
            Términos y Condiciones
          </button>
        </div>
      </footer>

      {/* Modal */}
      <AnimatePresence data-id="element-86">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-dark-brown/60 backdrop-blur-sm" onClick={() => setActiveModal(null)} data-id="element-87">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.3,
          ease: 'easeOut'
        }} className="bg-cream rounded-2xl shadow-2xl max-w-2xl w-full max-h-[80vh] overflow-y-auto relative" onClick={e => e.stopPropagation()} data-id="element-88">
              <div className="sticky top-0 bg-cream border-b border-cinnamon/10 px-6 py-4 flex items-center justify-between rounded-t-2xl" data-id="element-89">
                <h2 className="font-serif text-lg font-bold text-dark-brown" data-id="element-90">
                  {activeModal === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
                </h2>
                <button onClick={() => setActiveModal(null)} className="text-dark-brown/50 hover:text-dark-brown transition-colors p-1 rounded-full hover:bg-dark-brown/10" data-id="element-91">
                  <X className="w-5 h-5" data-id="element-92" />
                </button>
              </div>
              <div className="px-6 py-6 text-sm leading-relaxed" data-id="element-93">
                {activeModal === 'privacy' ? privacyContent : termsContent}
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}